<template>
  <div :class="getClassName">
    <div class="matrix_selectOptionName">
      {{ name }} <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
    </div>
    <SelectOption
      v-if="!isSelectPopup"
      :id="getId"
      v-model="value"
      :options="options"
      :settings="settings"
    />
    <div v-if="isSelectPopup" class="selected" @click="setActivePageOption">
      <span>{{ getSelectedValue }}</span>
    </div>
    <appPopup
      v-if="isSelectPopup && isActive"
      :key="propsData.code"
      :propsData="propsData"
      :selectId="'options_select_' + propsData.code"
    ></appPopup>
    <input
      v-if="showColorPickerForOption"
      id="margin_color_input"
      type="color"
      :value="getMarginColor"
      style="width: 100%; cursor: pointer"
      @change="proccessMarginColor"
    />
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useActiveOptionStore } from "@/stores/modules/activeOption";
import { useTooltipsStore } from "@/stores/modules/tooltips";
import { mapState, mapActions } from "pinia";
import Popup from "../base/Popup";
import * as R from "ramda";

import { v4 as uuidv4 } from "uuid";
import { i18n } from "../../i18n.js";

import { createApp } from "vue";
import TooltipBase from "../ui/TooltipBase.vue";
import { Tooltip } from "floating-vue";

export default {
  components: {
    appPopup: Popup
  },
  computed: {
    ...mapState(useChangeOptionsStore, ["getSummary"]),
    ...mapState(useImageEditorStore, [
      "getMarginColor",
      "getEnableWhiteMargin"
    ]),
    ...mapState(useActiveOptionStore, ["getActivePageOption"]),
    ...mapState(useWebproductStore, [
      "getLayoutType",
      "getHideSearchBoxInPoptext",
      "getSelector",
      "getVueInstance",
      "getIsPackingEnabled",
      "getIsLfp",
      "getNumberOfUploads",
      "getSweetAlert"
    ]),
    ...mapState(useTooltipsStore, [
      "getShowTooltipsInPOPoptext",
      "getShowTooltipsInPOVPoptext",
      "getIsTooltipsActive",
      "getTooltipContent"
    ]),
    name: function () {
      return this.propsData.name;
    },
    options: function () {
      return this.propsData.values;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOPoptext && this.propsData.tooltip;
    },
    settings: function () {
      var multiple = 0;
      if (this.propsData.type && this.propsData.type == "multiple") {
        multiple = 1;
      }
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { multiple, ...hideOptions };
    },
    isActive: function () {
      if (this.getActivePageOption == this.propsData.code) {
        return true;
      }
      return false;
    },
    isSelectPopup: function () {
      return this.propsData.is_popup && this.getIsLfp ? 1 : 0;
    },
    getSelectedValue: function () {
      var title = "";
      if (this.propsData.selected[0]) {
        var selectedId = this.propsData.selected[0];
        var options = R.filter(function (item) {
          if (item.id == selectedId) return item;
        }, this.propsData.values);
        if (options.length) {
          title = options[0].text;
        }
      }
      return title;
    },
    value: {
      get: function () {
        return this.propsData.type && this.propsData.type == "multiple"
          ? this.propsData.selected
          : this.propsData.selected[0];
      },
      set: function (newValue) {
        if (
          this.propsData.code === "paper" &&
          this.getIsPackingEnabled &&
          this.getNumberOfUploads > 0
        ) {
          this.getSweetAlert({
            text: i18n.t(
              "If you change the paper, you will need to upload the artwork again!"
            ),
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: i18n.t("Cancel"),
            confirmButtonText: i18n.t("Ok")
          }).then(userAction => {
            if (userAction.isConfirmed) {
              this.afterChangePageOption(newValue);
              const event = new Event("pqMatrix_paperChanged");
              window.document.dispatchEvent(event);
            } else {
              this.afterChangePageOption(this.value);
            }
          });
        } else {
          this.afterChangePageOption(newValue);
        }
      }
    },
    showColorPickerForOption: function () {
      return (
        this.value === "oie_margin_type_monochromatic" &&
        !this.getEnableWhiteMargin &&
        this.getLayoutType === "image_editor"
      );
    },
    getId: function () {
      return this.getSelector + "_" + this.selectId + "_" + uuidv4();
    }
  },
  methods: {
    ...mapActions(useChangeOptionsStore, ["setPageOption"]),
    ...mapActions(useImageEditorStore, ["changeMarginColor"]),
    ...mapActions(useActiveOptionStore, ["setActivePageOptionCode"]),
    //...mapMutations(["changeMarginColor"]),
    proccessMarginColor: function (event) {
      this.changeMarginColor(event.target.value);
    },
    afterChangePageOption: function (newValue) {
      this.setPageOption({
        value: newValue,
        layout: false,
        option: this.propsData.code,
        optionType: this.optionType
      });
    },
    getPOValueTooltip: function (id) {
      for (var idx in this.propsData.values) {
        if (this.propsData.values[idx].id == id) {
          return this.propsData.values[idx].tooltip;
        }
      }
      return null;
    },
    unsetActivePageOption: function () {
      this.setActivePageOptionCode("");
    },
    setActivePageOption: function () {
      if (this.propsData.code == this.getActivePageOption) {
        this.setActivePageOptionCode("");
      } else {
        this.setActivePageOptionCode(this.propsData.code);
      }
    }
  },
  mounted: function () {
    if (!this.getIsTooltipsActive || !this.getShowTooltipsInPOVPoptext) {
      return;
    }
    const that = this;
    jQuery("#" + this.getId).on("select2:open", function (params) {
      setTimeout(function () {
        var id = jQuery("#select2-" + that.getId + "-results");
        if (id.length) {
          id = id[0];
          for (var i in id.children) {
            var item = id.children[i];
            if (typeof item == "object") {
              if (
                !that.options[i].tooltip ||
                !that.getTooltipContent(that.options[i].tooltip)
              ) {
                continue;
              }
              const selectId = "select_tooltip_" + i;
              jQuery(item).append("<div id='" + selectId + "'></div>");
              const buttonInstance = createApp(TooltipBase, {
                tooltip: that.options[i].tooltip,
                tooltipContent: that.getTooltipContent(that.options[i].tooltip),
                isPoptext: true
              });
              buttonInstance.component("VTooltip", Tooltip);
              buttonInstance.mount("#" + selectId);
              jQuery(item).append(buttonInstance);
            }
          }
        }
      }, 100);
    });
  },
  props: ["propsData", "optionType", "selectId"]
};
</script>
